import { GetSidebarItemFn, GetSidebarLinkFn, GetSidebarLinkMenuFn } from "@/components/layout/Sidebar/sidebar.types";

export const dashboardItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "dashboard",
    title: "Dashboard",
    icon: "lely-icon-dashboard",
});

const engineeringMenuLinks: GetSidebarLinkFn[] = [
    () => ({
        _type: "link",
        route: "connectionPerformance",
        title: "Connection Performance",
        icon: "lely-icon-human",
    }),
    () => ({ _type: "link", route: "mfpBimodality", title: "MFP Bimodality", icon: "lely-icon-diagram" }),
    () => ({ _type: "link", route: "mfpPlotter", title: "MFP Plotter", icon: "lely-icon-graph" }),
    () => ({ _type: "link", route: "TDSLinerAdvice", title: "TDS Liner Advice", icon: "lely-icon-diagram" }),
];

export const engineeringMenu: GetSidebarLinkMenuFn = () => ({
    _type: "menu",
    title: "Engineering",
    icon: "lely-icon-graph",
    links: engineeringMenuLinks,
});
